var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"homePop"},[_c('div',{staticClass:"pxindBox"},[_c('img',{staticClass:"pxind",attrs:{"src":_vm.popupData.images,"alt":""},on:{"click":_vm.jumpCourseDetail}}),_c('img',{staticClass:"closepxind",attrs:{"src":require("@/assets/img/loginImg/closeRemind.png"),"alt":""},on:{"click":_vm.closePopBox}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }